export default {
  get_all: { method: "get", url: "api/cnpj" },
  show: { method: "get", url: "api/cnpj{/id}" },
  store: { method: "post", url: "api/cnpj" },
  update: { method: "put", url: "api/cnpj{/id}" },
  delete: { method: "delete", url: "api/cnpj{/id}" },
};
